import type { IconData } from '@stacksjs/iconify-core'

export const userPodcast: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M28.192 31.815a8 8 0 1 0-8.383 0c-3.845 1.555-6.757 5.184-7.576 9.632c-.297 1.615.627 2.933 2.257 3.138c1.732.218 4.643.415 9.511.415s7.78-.197 9.512-.415c1.629-.205 2.553-1.523 2.256-3.138c-.819-4.449-3.731-8.079-7.577-9.632\"/><path d=\"M3 24.075C3 12.88 12.512 4 24 4s21 8.88 21 20.075c0 2.974-.68 5.803-1.896 8.344c-.711 1.488-2.59 1.84-3.96.923l-.849-.568c-1.152-.772-1.43-2.33-.88-3.603a12.8 12.8 0 0 0 1.052-5.096c0-7.352-6.32-13.59-14.467-13.59S9.533 16.723 9.533 24.075c0 1.798.372 3.518 1.053 5.096c.549 1.274.271 2.83-.881 3.603l-.85.568c-1.37.918-3.248.565-3.96-.923A19.3 19.3 0 0 1 3 24.075\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default userPodcast
